var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.893 2H4.107C3.25 2 2.5 2.7 2.5 3.5v13c0 .8.75 1.5 1.607 1.5h11.786c.857 0 1.607-.7 1.607-1.5v-13c0-.8-.75-1.5-1.607-1.5zM6.875 15.511c0 .208-.219.415-.438.415H5.125c-.219 0-.438-.207-.438-.415v-1.244c0-.208.22-.415.438-.415h1.313c.218 0 .437.207.437.415v1.244zm0-3.852c0 .208-.219.415-.438.415H5.125c-.219 0-.438-.207-.438-.415v-1.244c0-.208.22-.415.438-.415h1.313c.218 0 .437.207.437.415v1.244zm4.375 3.852c0 .208-.219.415-.438.415H9.5c-.219 0-.438-.207-.438-.415v-1.244c0-.208.22-.415.438-.415h1.313c.218 0 .437.207.437.415v1.244zm0-3.852c0 .208-.219.415-.438.415H9.5c-.219 0-.438-.207-.438-.415v-1.244c0-.208.22-.415.438-.415h1.313c.218 0 .437.207.437.415v1.244zm4.063 3.872c0 .197-.22.395-.438.395h-1.313c-.218 0-.437-.198-.437-.395v-5.136c0-.197.219-.395.438-.395h1.312c.219 0 .438.198.438.395v5.136zm0-8.02c0 .208-.213.415-.426.415H5.114c-.213 0-.426-.207-.426-.415V4.193c0-.208.213-.415.425-.415h9.775c.213 0 .425.207.425.415V7.51z",
    fill: "#B6E0FE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.51e0087a.svg";
export { ForwardRef as ReactComponent };